import { BasicButton, ButtonGroup, PrimaryButton } from "@certn/cascadia";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

import { BillingDetailsModal } from "./BillingDetailsModal";
import { useApplyLink } from "../../hooks/useApplyLink";
import { Schemas } from "../../types";
import { CopyLinkButton } from "../copy-link-button/CopyLinkButton";
interface PackageActionsProps {
  customerGroup: { billing_profile: { currency: string } } | undefined;
  defaultApplyLink?: Schemas["PackageDefaultApplyLink"] | null;
  applyLinkData: { link: string } | undefined;
  testID: string;
  onPress: () => void;
  onCreateApplyLink: () => void;
  canApplyLinkBeCreated?: boolean;
}

export function PackageActions({
  customerGroup,
  defaultApplyLink,
  applyLinkData,
  testID,
  onPress,
  onCreateApplyLink,
  canApplyLinkBeCreated,
}: PackageActionsProps) {
  const { t } = useTranslation();
  const {
    isBillingDetailsModalOpen,
    billingProfileId,
    setIsBillingDetailsModalOpen,
    onPressCreateApplyLink,
  } = useApplyLink(onCreateApplyLink);

  return (
    <>
      <ButtonGroup justify="space-between" className={styles.flexOne}>
        {customerGroup?.billing_profile &&
          defaultApplyLink &&
          applyLinkData?.link && (
            <CopyLinkButton
              url={applyLinkData.link}
              title={t("Copy apply link")}
              icon="content_copy"
            />
          )}
        {customerGroup?.billing_profile && !defaultApplyLink && (
          <BasicButton
            size="medium"
            onPress={onPressCreateApplyLink}
            testID={`${testID}-create-apply-link-button`}
            isDisabled={canApplyLinkBeCreated === false}
            leftIcon={canApplyLinkBeCreated === false ? "lock" : undefined}
          >
            <Trans>Create apply link</Trans>
          </BasicButton>
        )}
        <PrimaryButton
          onPress={onPress}
          testID={`${testID}-select-package-button`}
          size="medium"
        >
          <Trans>Select package</Trans>
        </PrimaryButton>
      </ButtonGroup>
      <BillingDetailsModal
        billingProfileId={billingProfileId}
        isOpen={isBillingDetailsModalOpen}
        onClose={() => setIsBillingDetailsModalOpen(false)}
      />
    </>
  );
}

const styles = {
  flexOne: css({
    flex: 1,
  }),
};
